import { DocumentDisplayModel } from '@/api/model-index';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DialogCloseResult, DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { FocusManagedDialogComponent } from '../../dialogs/focus-managed-dialog.component';
import { FocusService } from '@/core/services/focus.service';
import { I18nService } from '@/core/services/i18nService';

@Component({
  selector: 'document-selection-dialog',
  templateUrl: './document-selection-dialog.component.html',
  styleUrls: ['./document-selection-dialog.component.scss']
})
export class DocumentSelectionDialogComponent extends FocusManagedDialogComponent implements OnInit {

  public formGroup: FormGroup;

  @Input()
  public documents: DocumentDisplayModel[];

  constructor(dialog: DialogRef, protected fb: FormBuilder, protected focusService: FocusService, protected languageService: I18nService) {
    super(focusService,dialog);
  } 
  

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      documents: this.fb.array([]),
      toggleAll: true
    })
    this.documents.forEach(document => {
      this.documentFormArray.push(this.fb.group({
        download: true,
        document: document,
      }));
    })

    this.documentFormArray.valueChanges.subscribe((controls: FormControl[])  => {
      let trueCounted = controls.filter((control: any) => control.download).length;
      let falseCounted = controls.filter((control: any) => !control.download).length;

      if(falseCounted > 0 && trueCounted > 0) {
        this.formGroup.controls.toggleAll.patchValue(false);
      }
      if (trueCounted == this.documents.length) {
        this.formGroup.controls.toggleAll.patchValue(true);
      }

    });
  }

  get documentFormArray() : FormArray {
    return this.formGroup.get("documents") as FormArray;
  }

  get isDownloadDisabled(): boolean {
    return !this.documentFormArray.controls.find(control => control.value.download);
  }

  getFormControlByRowIndexAndName(rowIndex: number, formControlName: string): any {
    return this.documentFormArray.at(rowIndex).get(formControlName);
  }

  getFileName(dataItem: DocumentDisplayModel): string {
    return dataItem.name?.substring(0, dataItem.name.lastIndexOf('.')) +"";
  }

  getFileType(dataItem: DocumentDisplayModel): string {
    return dataItem.name?.substring(dataItem.name.lastIndexOf('.'), dataItem.name.length) +"";
  }

  getFileSize(dataItem: DocumentDisplayModel): string {
    if (!dataItem.fileSize)
      dataItem.fileSize = 0;

    return (dataItem.fileSize/1024/1024).toFixed(2) +" MB";
  }

  getCheckBoxName(rowIndex: number): string {
    return this.languageService.instant('ausschreibung.unterlagen.grid.download') +" "+ this.documents[rowIndex].name;
  }

  toggleAll() {
    if(this.formGroup.controls.toggleAll.value) {
      this.documentFormArray.controls.forEach(control => {
        let controlValue = control.value;
        control.patchValue({
          download: false,
          document: controlValue.document
        })
      });
    }
    else {
      this.documentFormArray.controls.forEach(control => {
        let controlValue = control.value;
        control.patchValue({
          download: true,
          document: controlValue.document
        })
      });
    }
  }

  public closeDialog(download: boolean) {
    let result: UnterlagenDialogResult = new UnterlagenDialogResult();
    if (download)
      result.documentsToDownload = this.documentFormArray.value.filter((val: any) => val.download).map((val: any) => val.document);
    this.dialog.close(result);
  }
}

export class UnterlagenDialogResult extends DialogCloseResult {
  public documentsToDownload: DocumentDisplayModel[];
}